import { types } from '../actions/types';
import uniq from 'lodash/uniq';

const DEFAULT_STATE = {
    providers: null,
    clients: [],
    selectedClient: null,
    selectedProvider: null,
}

export default (state = DEFAULT_STATE, action) => {
    
    switch (action.type) {
        case types.GET_ALL_DB_PROVIDERS:
            return {
                ...state, providers: action.payload
            }
        case types.GET_PROVIDER_CLIENTS: 
            // console.log('PAYLOAD FROM GET_PROVIDER_CLIENTS', action.payload);
            return {
                ...state, clients: uniq((state.clients.length > 0) ? [...state.clients, ...action.payload] : [...action.payload])
            }
        case types.GET_PROVIDER_DATA:
            return {
                ...state, selectedProvider: action.payload
            }
        case types.SET_SELECTED_CLIENT_SUCCESS: 
            return {
                ...state, selectedClient: action.payload
            }
        case types.SET_SELECTED_CLIENT_FAIL: 
            return {
                ...state, selectedClient: null
            }
        case types.ADD_ACTIVE_CLIENT_SUCCESS: 
            return {
                ...state, activeClients: (state.activeClients && state.activeClients.length > 0) ? [...state.activeClients, action.payload] : [action.payload]
            }
        case types.ADD_PENDING_CLIENT_SUCCESS: 
            return {
                ...state, pendingClients: (state.pendingClients && state.pendingClients.length > 0) ? [...state.pendingClients, action.payload] : [action.payload]
            }
        case types.ADD_INACTIVE_CLIENT_SUCCESS: 
            return {
                ...state, inactiveClients: (state.inactiveClients && state.inactiveClients.length > 0) ? [...state.inactiveClients, action.payload] : [action.payload]
            }
        case types.LOG_OUT_SUCCESS:
            return {
                ...DEFAULT_STATE
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/provider-reducer.js